import axios from 'axios';
//const BASE_URL = process.env.REACT_APP_BACKEND_API;
const BASE_URL = 'https://atom.hotbym.com/api' || process.env.REACT_APP_BACKEND_API || 'http://localhost:5700/api';

export default axios.create({
    baseURL: BASE_URL
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});

